// src/graphql/queries/sessionQueries.js

export const getSessions = () => `query GetSessions($userId: String, $activeOnly: Boolean, $limit: Int, $offset: Int) {
    adminSessions(userId: $userId, activeOnly: $activeOnly, limit: $limit, offset: $offset) {
        id
        userId
        token
        ipAddress
        userAgent
        expiresAt
        createdAt
        isImpersonation
        impersonatedById
        impersonatedBy {
            id
            email
            firstName
            lastName
        }
    }
}`;

// Lighter query for counting sessions - avoids impersonatedBy which can fail
// if the impersonating admin user was deleted (FK sets null but resolver may expect non-null)
export const getSessionsBasic = () => `query GetSessionsBasic($userId: String, $activeOnly: Boolean, $limit: Int, $offset: Int) {
    adminSessions(userId: $userId, activeOnly: $activeOnly, limit: $limit, offset: $offset) {
        id
        userId
        expiresAt
        createdAt
        isImpersonation
    }
}`;

export const getSession = () => `query GetSession($id: String!) {
    adminSession(id: $id) {
        id
        userId
        token
        ipAddress
        userAgent
        expiresAt
        createdAt
        isImpersonation
        impersonatedById
        impersonatedBy {
            id
            email
            firstName
            lastName
        }
    }
}`;
